import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { SectionsService } from '../../../../services/sections.service';
import { ClaimsService } from '../../../../services/claims.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-participant-provvider-rates',
  standalone: true,
  imports: [ButtonComponent, ListTableComponent],
  templateUrl: './participant-provider-rates-list.component.html',
  styleUrl: './participant-provider-rates-list.component.css',
})
export class ParticipantProviderRatesListComponent {
  sharedDataKey: string = STATIC_DATA.SHARED_PARTICIPANT_PROVIDER_RATES_DATA;
  pageId: string = PAGE_CONSTANTS.PARTICIPANT_PROVIDER_RATES_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  programName!: string;
  lazyLoad = true;

  constructor(
    private router: Router,
    private sharedDataService: SharedDataService,
    private sectionService: SectionsService, private claimsService: ClaimsService, private userService: UserService,
    private allowListStore: AllowListAuthStore
  ) {
  }

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }
  onAddParticipantProviderRates() {
    this.router.navigate(['/home/addParticipantProviderRates', 'add']);
  }

  rowClicked(rowDetail: any) {
    this.userService.setLeadEntry('associationRates');
    this.sectionService.setFlow('associationRates');
    this.userService.setSelectedId(rowDetail.ptcPrvdrXRatesId);
    this.claimsService.getParticipantProviderRates(
      this.programName,
      rowDetail.ptcPrvdrXRatesId,
      false
    )
      .subscribe((data: any) => {
        data.responsedata['ptcPrvdrXRatesId'] = rowDetail.ptcPrvdrXRatesId;
        this.claimsService.setFormData('association_rates', data.responsedata);
        setTimeout(() => {
          this.router.navigate(['/home/addParticipantProviderRates', 'update']);
        }, 200);
      });
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }
}
